import { useState } from 'react';
import { Link } from 'react-router-dom';
import ContactModal from './ContactModal';

export default function Footer() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const footerLinks = {
    company: [
      { label: 'ビジョン', href: '/vision' },
      { label: '会社概要', href: '/会社概要' }
    ],
    project: [
      { label: '廃校活用プロジェクト', href: '/project' },
      { label: '陸上養殖技術', href: '/technology' },
      { label: '地域社会への貢献', href: '/community' },
      { label: 'サステナビリティ', href: '/sustainability' }
    ],
    contact: [
      { label: 'お問い合わせ', href: '/contact' }
    ]
  };

  return (
    <>
      <footer className="bg-[#1A2332] text-white pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
            <div className="lg:col-span-2">
              <div className="mb-6">
                <img
                  src="https://storage.readdy-site.link/project_files/fc18929a-f6b4-4a9e-92ee-da32c9ea052d/4fe99e4d-15c2-4d8e-866a-3f5c5aac6b65_C8209D2BDE10963017F26F59233783C418DCE6A2.png?v=985436ac8d52cc034e4e004462d1a98f"
                  alt="C.GREEN 株式会社シーグリーン"
                  className="h-40 w-auto object-contain"
                />
              </div>
              <p className="text-gray-400 text-base leading-relaxed">
                廃校を活用した循環型陸上養殖プロジェクトを通じて、持続可能な地域社会の実現に貢献します。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white text-lg mb-4">会社情報</h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-[#2D7A3E] transition-colors text-base cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white text-lg mb-4">プロジェクト</h4>
              <ul className="space-y-3">
                {footerLinks.project.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-gray-400 hover:text-[#2D7A3E] transition-colors text-base cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white text-lg mb-4">お問い合わせ</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => setIsContactOpen(true)}
                    className="text-gray-400 hover:text-[#2D7A3E] transition-colors text-base cursor-pointer whitespace-nowrap bg-transparent border-0 p-0"
                  >
                    お問い合わせ
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <div className="text-base text-gray-400">
                <p className="mb-1">本社: 山口県下関市長府浜浦南町5-28</p>
                <p>つくば事務所: 茨城県つくば市天久保3-10-7</p>
              </div>
              <p className="text-base text-gray-400">
                © 2024 C.GREEN Corporation. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
    </>
  );
}